import React from "react";
import { Card, CardContent, Typography, TextField } from "@mui/material";
import PropTypes from "prop-types";

function CompanyDetailsCard({
  title,
  value,
  onChange,
  onBlur,
  placeholder,
  isSaved,
  isEditing,
  disabled,
}) {
  return (
    <Card
      sx={{
        minHeight: 260,
        boxShadow: 3,
        borderRadius: 2,
        border: isSaved
          ? "2px solid green"
          : isEditing
          ? "2px solid #fbc02d"
          : "2px solid transparent",
        transition: "border 0.3s ease-in-out",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography variant="h6" fontWeight="bold" align="center">
          {title}
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={8}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          variant="outlined"
          sx={{
            mt: 1,
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "transparent" },
              "&:hover fieldset": { borderColor: "#ccc" },
              "&.Mui-focused fieldset": { borderColor: "#ccc", boxShadow: "none" },
            },
          }}
        />
      </CardContent>
    </Card>
  );
}

CompanyDetailsCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  isSaved: PropTypes.bool.isRequired,
  isEditing: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default CompanyDetailsCard;
